module.exports = __webpack_public_path__ + "static/img/weiLai.89a0de3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/CustomersInfo/weiLai.png
// module id = XUBZ
// module chunks = 19